import axios from 'axios';
import moment from 'moment';
import apiService from '../apiService';

function base64ToBlob(base64, mime = "image/png") {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mime });
}

export default async function uploadFileToS3AndCreateMetadata(
  token = "",
  contractId = 0,
  guestId = "",
  guestSignature
) {
  try {
    const presignedUrl = await getPresignedUrl();
    await uploadToS3(presignedUrl, guestSignature);
    await createFileMetadata(presignedUrl);
    return presignedUrl.url;
  } catch (error) {
    console.error("Error uploadToS3", error);
    throw error;
  }

  async function getPresignedUrl() {
    const options = {
      url: `${apiService.getUrl().externalBase}public/api/files/presignedurl`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        Accept: "text/plain",
      },
      data: {
        Ext: "png",
        Expiration: moment().add(5, "minutes").toISOString(),
        ContentType: "image/png",
        ContractId: contractId,
      },
    };

    const _ret = await axios(options);
    return _ret.data.Data;
  }

  async function uploadToS3(presignedUrl, base64File) {
    const blob = base64ToBlob(base64File.split(',')[1], "image/jpeg");
    const response = await fetch(presignedUrl.url, {
      method: "PUT",
      headers: { "Content-Type": "image/png" },
      body: blob,
    });

    if (!response.ok) {
      console.error("🚨 Erro no upload:", response.status, response.statusText);
      throw new Error("UPLOAD_ERROR");
    }

    console.log("✅ Upload completo:", response.status);

    return response.url;
  }

  async function createFileMetadata(presignedUrl) {
    const options = {
      url: `${apiService.getUrl().externalBase}public/api/files/create`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        Accept: "text/plain",
      },
      data: {
        Ext: "png",
        Name: `guest_face_recognition_${guestId}`,
        Table: "TB_PAX",
        TableId: parseInt(guestId),
        Expiration: moment().toISOString(),
        Key: presignedUrl.key,
        ContractId: contractId,
      },
    };
    return axios(options);
  }
}
